import type {
	ComparisonCommitParams,
	ComparisonExchangesParams,
	ComparisonHistoryParams,
	ComparisonSideReferenceParams,
} from "@/app/components/Comparison/types/comparison.interface"

export const COMPARISON_QUERY_OPTIONS = {
	staleTime: 0,
	refetchOnMount: "always" as const,
	refetchOnWindowFocus: true,
}

const COMPARISON_ROOT = ["comparison"] as const

export const COMPARISON_QUERY_KEYS = {
	root: COMPARISON_ROOT,
	exchangesRoot: [...COMPARISON_ROOT, "exchanges"] as const,
	exchanges: (params: ComparisonExchangesParams) =>
		[
			...COMPARISON_ROOT,
			"exchanges",
			params.market,
			params.side,
			String(params.amount),
			params.source,
		] as const,
	sideReference: (params: ComparisonSideReferenceParams) =>
		[...COMPARISON_ROOT, "side-reference", params.market, params.side, params.source] as const,
	quotesRoot: [...COMPARISON_ROOT, "quotes"] as const,
	quote: (params: ComparisonExchangesParams) =>
		[
			...COMPARISON_ROOT,
			"quotes",
			params.market,
			params.side,
			String(params.amount),
			params.source,
		] as const,
	commit: (params?: ComparisonCommitParams) =>
		[
			...COMPARISON_ROOT,
			"commit",
			params?.exchange ?? null,
			params?.symbol ?? null,
			params?.currency ?? null,
			params?.side ?? null,
			params?.amount !== undefined ? String(params.amount) : null,
			params?.source ?? null,
		] as const,
	historyRoot: [...COMPARISON_ROOT, "history"] as const,
	history: (params: ComparisonHistoryParams) =>
		[
			...COMPARISON_ROOT,
			"history",
			params.limit,
			params.offset,
			params.from_date ?? null,
			params.to_date ?? null,
			params.source ?? null,
			params.symbol ?? null,
		] as const,
	order: () => [...COMPARISON_ROOT, "order"] as const,
	altPrice: (symbol?: string) => [...COMPARISON_ROOT, "alt-price", symbol?.toUpperCase() ?? ""] as const,
}
